import React from 'react';
import { Snackbar, Alert, Stack, Typography, Fade } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setSnackError } from '../../Reducers/snackErrors';
import { ErrorOutlineOutlined, ErrorOutlineRounded } from '@mui/icons-material';

const ErrorSnack = () => {
  const dispatch = useDispatch();
  const title = useSelector((state) => state.errors.title);
  const body = useSelector((state) => state.errors.body);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(setSnackError({title: null, body: null}));
  };

  return (
    <Snackbar
      open={title != null}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      TransitionComponent={Fade}
      sx={{
        '&.MuiSnackbar-root': {
          bottom: { xs: 16, sm: 24 },
          right: { xs: 16, sm: 24 },
        }
      }}
    >
  <Alert 
    onClose={handleClose} 
    severity="error"
    variant="filled" // or "outlined" based on your theme
    sx={{ 
      width: '100%',
      maxWidth: 400,
      boxShadow: 3,
      borderRadius: 1,
      backgroundColor: theme => theme.palette.error.light, // Darker red for errors
      color: theme => theme.palette.error.contrastText,
      '& .MuiAlert-icon': {
        alignItems: 'center',
        fontSize: '1.5rem',
        color: theme => theme.palette.error.contrastText
      },
      '& .MuiAlert-message': {
        py: 1,
        width: '100%'
      },
      '& .MuiAlert-action': {
        alignItems: 'flex-start',
        pt: 0.5
      }
    }}
    iconMapping={{
      error: <ErrorOutlineRounded fontSize="inherit" />
    }}
  >
    <Stack spacing={0.5}>
      <Typography 
        fontWeight={600} 
        variant="subtitle1"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          color: 'inherit'
        }}
      >
        {title}
      </Typography>
      <Typography 
        variant="body2"
        sx={{
          color: theme => theme.palette.mode === 'dark' ? 
            'rgba(255,255,255,0.85)' : 
            'rgba(255,255,255,0.9)'
        }}
      >
        {body}
      </Typography>
    </Stack>
  </Alert>
</Snackbar>
  );
};

export default ErrorSnack;
